import React from 'react'
import styled from 'styled-components'
import {formatDate} from '../../../utils/time'
import {_L, useLocaleState} from '../../../context/LocaleContext'

const Label = styled.div`
  font-size: ${props => (props.small ? '12px' : '14px')};
  color: #a4a9b7;
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 5px 5px 0 0;
  box-sizing: border-box;
  padding: 18px 20px 18px 20px;
  background-color: white;
  border-bottom: 1px solid #f3f5fb;
  &:hover {
    background-color: #f3f9ff;
  }
`

const Workstation = styled.div`
  font-size: 16px;
  font-weight: 600;
`

const Employee = styled.div`
  font-size: 14px;
  font-weight: 600;
`

const Date = styled.div`
  font-size: 14px;
`
const getFloorLabel = (dpId, flId, floorText) =>
  dpId ? `${dpId} - ${floorText} ${flId}` : `${floorText} - ${flId}`

const WorkspaceItem = ({reservation, onSelect}) => {
  const localeState = useLocaleState()

  const onClick = () => {
    onSelect(reservation)
  }

  const {
    rmId,
    dpId,
    flId,
    emId,
    dateStart,
    dateEnd,
    description,
    visitorsNameFirst,
    visitorsNameLast
  } = reservation

  const name =
    visitorsNameFirst && visitorsNameLast
      ? visitorsNameFirst + ' ' + visitorsNameLast
      : emId

  return (
    <Container onClick={onClick}>
      <div>
        <Workstation>
          {rmId} {description}
        </Workstation>
        <Label>
          {getFloorLabel(dpId, flId, _L({key: 'Floor', localeState}))}
        </Label>
      </div>
      <div>
        <Label small>{_L({key: 'For:', localeState})}</Label>
        <Employee>{name}</Employee>
      </div>
      <div>
        <Label small>{_L({key: 'Start date:', localeState})}</Label>
        <Date>{formatDate(dateStart, 'L')}</Date>
      </div>
      <div>
        <Label small>{_L({key: 'End date:', localeState})}</Label>
        <Date>{formatDate(dateEnd, 'L')}</Date>
      </div>
    </Container>
  )
}

export default WorkspaceItem
